import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

export const Top = styled(Stack)`
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({theme}) => theme.colors.borderSecondary};

  ${({theme}) =>
    theme.respondTo(
      'md',
      css`
        margin-bottom: 12px;
        padding-bottom: 12px;
      `
    )}
`;
